import swtAlert from "lib/sweetAlert";

export { swtAlert };

export function alertError(title, text) {
  return swtAlert.error(title, text);
}

export async function confirmAction({
  title = "Confirm",
  text = "",
  confirmText = "Yes",
  cancelText = "Cancel",
}) {
  const result = await swtAlert.warning(title, text, confirmText, cancelText);
  return result.isConfirmed;
}

export function alertSessionExpired() {
  return swtAlert.info(
    "Session expired",
    "Please log in again to continue.",
    "OK"
  );
}
